export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-fire-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-xl text-background-50">黑料每日大赛</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              国内领先的娱乐八卦资讯聚合平台，每日追踪全网最热黑料，打造吃瓜群众首选社区。最新黑料排行榜与大赛排名实时更新，劲爆内容一站浏览。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '热度排行榜', href: '#ranking' },
                { label: '话题标签', href: '#topics' },
                { label: '专题精选', href: '#carousel' },
                { label: '内容索引', href: '#index' },
                { label: '平台特色', href: '#features' },
              ].map((item) => (
                <a key={item.label} href={item.href} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">关于我们</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '平台介绍', href: '#about' },
                { label: '联系我们', href: '#contact' },
                { label: '最新动态', href: '#updates' },
                { label: '常见问题', href: '#faq' },
                { label: '用户评论', href: '#comments' },
              ].map((item) => (
                <a key={item.label} href={item.href} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">合作伙伴</h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              更多合作伙伴信息敬请期待
            </p>
            <div className="mt-6">
              <h4 className="font-heading font-semibold text-background-50 mb-3 text-sm">关注我们</h4>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors">
                  <i className="ri-video-line"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors">
                  <i className="ri-bilibili-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2025 黑料每日大赛 版权所有 | 本站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}